module.exports = __webpack_public_path__ + "static/img/7.7b321e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/sp/7.png
// module id = 7WVT
// module chunks = 0